import React from "react";
import Link from "next/link";

const toc = [
  {
    topic: "Was bedeutet der Mercedes Stern?",
    anchor: "was-bedeutet-der-mercedes-stern",
  },
  {
    topic: "Woher kommt der Name Mercedes?",
    anchor: "woher-kommt-der-name-mercedes",
  },
  {
    topic: "Sie träumen von einem Mercedes-Benz?",
    anchor: "sie-traumen-von-einem-mercedes-benz",
  },
  {
    topic: "Wie viel kostet ein Mercedes bei Null-Leasing?",
    anchor: "wie-viel-kostet-ein-mercedes-bei-null-leasing",
  },
  {
    topic: "Was sind Mercedes Junge Sterne?",
    anchor: "was-sind-mercedes-junge-sterne",
    subTopics: [
      {
        topic: "Was kostet eine Garantieverlängerung?",
        anchor: "was-kostet-eine-garantieverlangerung",
      },
    ],
  },
  {
    topic: "Mercedes-Benz Modelle - Die beliebtesten Fahrzeuge im Überblick",
    anchor: "mercedes-benz-modelle-die-beliebtesten-fahrzeuge-im-uberblick",
  },
  {
    topic: "Mercedes SUV Leasing",
    anchor: "mercedes-suv-leasing",
    subTopics: [
      {
        topic: "Warum Mercedes Benz?",
        anchor: "warum-mercedes-benz",
      },
      {
        topic: "VIP Leasing Mercedes, was ist das?",
        anchor: "vip-leasing-mercedes-was-ist-das",
      },
      {
        topic: "Besondere Highlights erleben Sie bei Mercedes-Benz",
        anchor: "besondere-highlights-erleben-sie-bei-mercedes-benz",
      },
      {
        topic: "Diese Statistik spricht für sich.",
        anchor: "diese-statistik-spricht-fur-sich",
      },
      {
        topic: "Starke Technologie und modernes Design",
        anchor: "starke-technologie-und-modernes-design",
      },
      {
        topic: "So geht Innovation - Erleben Sie Technik schon jetzt!",
        anchor: "so-geht-innovation-erleben-sie-technik-schon-jetzt",
      },
      {
        topic: "Was bedeutet Avantgarde bei Mercedes?",
        anchor: "was-bedeutet-avantgarde-bei-mercedes",
      },
      {
        topic: "Ob alt oder neu - AMG bringt Power!",
        anchor: "ob-alt-oder-neu-amg-bringt-power",
      },
      {
        topic: "Was kostet ein AMG?",
        anchor: "was-kostet-ein-amg",
      },
      {
        topic: "Was kostet der teuerste Mercedes?",
        anchor: "was-kostet-der-teuerste-mercedes",
      },
      {
        topic: "Mehr Luxus geht nicht!",
        anchor: "mehr-luxus-geht-nicht",
      },
    ],
  },
];

export default ({ minLeasingRate }) => (
  <div className="page-container page-container--tight px-5 mb-1">
    <h2 className="headline--4 mb-4">
      Mercedes Leasing - Werden Sie jetzt fündig!
    </h2>
    <p className="mb-4">
      Das aus Stuttgart stammende Unternehmen ist bekannt für höchste Qualität,
      Zuverlässigkeit, Wertbeständigkeit und Tradition. Die eingetragene Marke der
      Daimler AG verfolgt diese Ziele seit ihrer Gründung in 1926 und entstand aus einer
      Fusion der beiden Motoren Gesellschaften von Carl Benz und Gottlieb Daimler. Die
      Daimler AG gilt seit 1998 laut ihrer Namensgebung als eine von Aktionären geführte
      Kapitalgesellschaft. Seit dem begeistert die Marke mit dem Stern, mit Modellen wie
      der Mercedes Benz A Klasse, dem GLC und dem vollelektrischen EQC den Markt
      und überzeugt durch ihr selbstbewusstes Auftreten und ihrer luxuriösen Art.
    </p>
    <ol className="mb-5 lg:mb-8">
      {toc.map(({ topic, anchor, subTopics }) => {
        if (subTopics && subTopics.length > 0) {
          return (
            <li key={anchor} className="text-secondary font-bold">
              {topic}
              <ul style={{ paddingLeft: "20px", listStyle: "disc" }}>
                {subTopics.map(({ topic, anchor }) => (
                  <li key={anchor} className="text-secondary font-bold">
                    <Link href={`#${anchor}`} className="link link--secondary">
                      {topic}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          );
        }
        return (
          <li key={anchor} className="text-secondary font-bold">
            <Link href={`#${anchor}`} className="link link--secondary">
              {topic}
            </Link>
          </li>
        );
      })}
    </ol>
    <div
      id="was-bedeutet-der-mercedes-stern"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Was bedeutet der Mercedes Stern?
      </h3>
      <p className="mb-4">
        Die drei Zacken des Mercedes Sterns stehen für den Einsatz der Daimler-Motoren
        zu Land, zu Luft und zu Wasser. Im weiteren Sinne könnte man ebenfalls
        Interpretieren, dass die drei Zacken des Sternes für die drei Säulen der Werte
        stehen die Mercedes mit seiner Marke vertritt. Diese Werte sind Qualität, Sicherheit
        und Tradition.
      </p>
    </div>
    <div
      id="woher-kommt-der-name-mercedes"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Woher kommt der Name Mercedes?
      </h3>
      <p className="mb-4">
        Der Markenname Mercedes, welcher der übergeordneten Daimler AG zuzuordnen
        ist entstand durch den Autohändler Emil Jellinek, der zu seiner Zeit als
        Geschäftsmann und Rennfahrer tätig war. Bei seinen zahlreichen Rennen meldete
        dieser sich unter dem Synonym “Mercedes Jellinek” an, was der Name seiner
        Tochter war. So wurde das junge Mädchen in kürzester Zeit zur Namensgeberin, der
        wohl berühmtesten Automarke der Welt.
      </p>
    </div>
    <div
      id="sie-traumen-von-einem-mercedes-benz"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Sie träumen von einem Mercedes-Benz?
      </h3>
      <p className="mb-4">
        Mit den Mercedes Leasing von Null-Leasing können auch Sie den Traum einen
        Mercedes zu fahren wahr werden lassen. Durch unsere zahlreichen auf Sie
        zugeschnittenen Angebote, haben Sie die freie Wahl, zwischen den besten
        Mercedes Modellen.
      </p>
      <p className="mb-4">
        Ob
        {" "}
        <b>
          SUV
        </b>
        ,
        {" "}
        <b>Limousine</b>
        {" "}
        oder
        {" "}
        <b>Kompaktwagen</b>
        , bei uns werden Sie fündig und das
        {" "}
        <b>
          ohne Anzahlung.
        </b>
      </p>
    </div>
    <div
      id="wie-viel-kostet-ein-mercedes-bei-null-leasing"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Wie viel kostet ein Mercedes bei Null-Leasing?
      </h3>
      <p className="mb-4">
        “Um einen Mercedes fahren zu können muss man Millionär sein!”. Nun, wer sich
        eines der höherpreisigen Mercedes Modelle kaufen will, sollte wohl etwas Geld
        beiseite gelegt haben. Doch zum Glück muss kein Mercedes gekauft werden um ihn
        fahren zu können. Bei Null-Leasing können Sie sich ganz bequem einen Mercedes
        Leasen, ohne Ihre kompletten Ersparnisse ausgeben zu müssen.
      </p>
      <p className="mb-4">
        So kann ein Mercedes Leasing schon ab
        {" "}
        {minLeasingRate}
        {" "}
        erfolgen. Mit dem Mercedes Leasing
        sichern Sie sich ein Fahrzeug des wohl berühmtesten Premium Fahrzeugherstellers
        der Welt. Sie können sich durch ein Mercedes Leasing auf feste monatliche Raten
        einstellen und haben das Fahrzeug nur für begrenzte Zeit, was ihnen einen
        schnellen Fahrzeugwechsel alle paar Jahre ermöglicht. Doch sein Sie schnell! Die
        Mercedes-Benz Leasing Angebote erneuern sich Regelmäßig und sind schnell
        vergriffen.
      </p>
    </div>
    <div
      id="was-sind-mercedes-junge-sterne"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">Was sind Mercedes Junge Sterne?</h3>
      <p className="mb-4">
        Die Jungen Sterne von Mercedes sind gebrauchte Mercedes-Benz Modell. Die
        Jungen gebrauchten werden meist nur für kurze Zeit gefahren und entsprechen dem
        Zustand eines Jahreswagens. Diese Fahrzeuge sind HU-geprüft und haben die
        Mercedes-Benz Gebrauchtfahrzeuggarantie. So wird Ihnen das volle Paket an
        Sicherheit und Service geboten und das auf alle Mercedes Modelle.
      </p>
    </div>
    <div
      id="was-kostet-eine-garantieverlangerung"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="paragraph font-bold mb-4">Was kostet eine Garantieverlängerung?</h3>
      <p className="mb-4">
        Mit dem Service und Garantie Paket von Mercedes-Benz sichern Sie sich ab und
        können sich guten Gewissens entspannen, während sich die qualifizierten
        Mitarbeiter von Mercedes im Falle einer allfälligen Reparatur um ihr Fahrzeug
        kümmern. Des weiteren wird bei Buchung eines Service oder Wartung und
        Verschleiß Paketes sämtliche Wartungs und Pflegekosten übernommen. Dieses
        Paket lässt sich im Austausch mit dem Händler individuell an ihre Wünsche
        anpassen oder ist bereits in dem Mercedes Leasing Angebot enthalten. Buchbar ist
        dieses Paket bei fast allen Mercedes Leasing und Mercedes Gebrauchtwagen
        Leasing Fahrzeugen. Der Startpreis einer Wartung beginnt bei 115€.
      </p>
    </div>
    <div
      id="mercedes-benz-modelle-die-beliebtesten-fahrzeuge-im-uberblick"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">Mercedes-Benz Modelle - Die beliebtesten Fahrzeuge im Überblick</h3>
      <p className="mb-4">
        Die Marke mit dem Stern, wer kennt sie nicht? Seit einher gilt Mercedes-Benz als
        DIE Automarke weltweit. Mit über 110 Jahren Historie ist Mercedes-Benz der wohl
        älteste Kraftfahrzeughersteller der Welt und ein Meister seines Handwerks. Ungleich
        zu jungen Automobilbauern wird bei Mercedes-Benz Tradition groß geschrieben und
        auf langjährige Erfahrung gesetzt.
      </p>
      <p className="mb-4">
        Wer dem Unternehmen jetzt nachsagen will, dass dieses sich auf den Basis
        Modellen wie der Mercedes
        {" "}
        <b>A Klasse</b>
        ,
        {" "}
        <b>C Klasse</b>
        , der
        {" "}
        <b>E Klasse</b>
        {" "}
        oder der
        {" "}
        <b>S Klasse</b>
        ausruht hat sich getäuscht. Das Unternehmen mit dem Stern brachte in den letzten
        10 Jahren über 20 neue Modelle heraus, welche sich auf neue und bereits
        vorhandene Fahrzeugkategorien verteilten. Besonders eine Fahrzeugkategorie hat
        sich in das Rampenlicht von Mercedes-Benz gerückt.
      </p>
      <p className="mb-4">
        Die
        {" "}
        <b>SUVs</b>
        !
      </p>
    </div>
    <div
      id="mercedes-suv-leasing"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Mercedes SUV Leasing
      </h3>
      <p className="mb-4">
        Sie mögen es groß, komfortable, sicher und dennoch luxuriös? Dann mögen Sie die
        SUV Flotte von Mercedes-Benz. Ob kultiger Offroader wie die
        {" "}
        <b>
          Mercedes-Benz G
          Klasse
        </b>
        , sportlicher kompakt SUV, wie der
        {" "}
        <b>GLC</b>
        {" "}
        oder luxuriöser Bolide wie dem
        {" "}
        <b>GLE</b>
        für Sie ist das richtige dabei.
      </p>
      <p className="mb-4">
        Mit einer Auswahl von insgesamt 9 verschiedenen SUVs ist Mercedes einer der
        größten deutschen Geländewagenhersteller und hat bereits in der Vergangenheit für
        viele positive Schlagzeilen mit seinen SUVs gesorgt. Nachdem der Vorgänger des
        {" "}
        <b>GLCs</b>
        {" "}
        bereits in 2014 zum
        {" "}
        <b>ADAC Testsieger</b>
        {" "}
        gekürt worden ist, stapfte sein
        Nachfolger nun in seine Fußstapfen. So wurde der
        {" "}
        <b>GLC</b>
        {" "}
        als das Erfolgsmodell unter
        den Premium-SUVs bekannt und verteidigte seitdem seine Position auf dem Markt.
      </p>
      <p className="mb-4">
        Durch seine Vielseitigkeit ist der Edel-SUV nicht nur bei einer Käufergruppe beliebt,
        sondern begeistert selbst Limousinen-Fans. Besonders das
        {" "}
        <b>GLC Coupe</b>
        {" "}
        ist bei
        jüngeren Zielgruppen beliebt, da er durch seine sportliche Eleganz und Leistung
        auftrumpft. Der Startpreis für einen GLC beträgt 42.248€ und
        {" "}
        {minLeasingRate}
        {" "}
        monatlich bei
        Null-Leasing.
      </p>
      <p className="mb-4">
        Für wen das GLC Coupe noch nicht groß genug sein sollte, gibt es das High End
        SUV
        {" "}
        <b>GLE Coupe</b>
        {" "}
        . Dieses Coupe überzeugt nicht nur von außen durch seine
        prachtvolle und imposante Art, durch den Diamantgrill und sein abfallendes Heck,
        sondern auch durch sein luxuriöses Interieur. Mit Komfort Highlights wie dem
        Energizing oder dem
        {" "}
        <b>Air Balance Paket</b>
        {" "}
        , den
        {" "}
        <b>
          Alcantara Multikontursitzen
        </b>
        {" "}
        und
        dem
        {" "}
        <b>
          MBUX Infotainmentsystem
        </b>
        , ist der
        {" "}
        <b>GLE</b>
        {" "}
        von innen, wie von außen, ein wahrer
        Eyecatcher.
      </p>
      <p>
        Sie wollen Platz für die ganze Familie und trotzdem den Komfort und Luxus eines
        Mercedes SUV? Dann kann der
        {" "}
        <b>Mercedes GLS</b>
        {" "}
        und
        {" "}
        <b>
          GLB
        </b>
        {" "}
        abhilfe schaffen. Durch
        die
        {" "}
        <b>7 Sitze</b>
        {" "}
        der beiden Familien tauglichen SUVs, haben Sie die Möglichkeit den
        Kofferraum mit einer dritten Sitzreihe auszustatten. So verwandeln Sie ihren
        herkömmlichen SUV, innerhalb weniger Sekunden in einen Familien Transporter.
      </p>
      <p className="mb-4">
        Wem ein solcher SUV doch zu groß sein sollte, doch trotzdem die Vorteile eines
        SUVs will, wird bei Mercedes fündig. Der sportliche Kompakt-SUV
        {" "}
        <b>Mercedes GLA</b>
        ist die perfekte Mischung, aus Limousine und Geländewagen. Durch seine
        dynamischen Proportionen und seine SUV typische bullige Front, hat der GLA den
        bequemen Einstieg und die gute Übersicht eines Geländewagens mit dem
        sportlichen Fahrgefühl einer Limousine. Doch der GLA glänzt nicht nur durch seine
        Vielseitigkeit, sondern auch durch Konfigurationsoptionen wie den 20 Zoll AMG
        Leichtmetallrädern oder dem Panoramadach.
      </p>
    </div>
    <div
      id="warum-mercedes-benz"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="paragraph font-bold mb-4">
        Warum Mercedes Benz?
      </h3>
      <p className="mb-4">
        Als einer der Top-Brands im Luxus Marken Segment steht Mercedes-Benz vor allem
        für eins,
        {" "}
        <b>Qualität</b>
        . Durch ihre langjährige Erfahrung als Fahrzeughersteller im
        Premium Segment, bietet Mercedes-Benz den Kunden mit ihren Produkten eine
        unvergleichbare Mixtur aus Luxus, Leistung und Qualität. Darum ist das Mercedes
        Leasing bei Geschäftskunde, sowie bei Privatkunden sehr beliebt.
      </p>
      <p className="mb-4">
        Wer denkt, dass Luxus erst ab einem Betrag von 80.000€ los geht der hat sich
        getäuscht. Bei Mercedes-Benz fängt Luxus bereits ab dem kleinsten ihrer
        zahlreichen Modelle an. Die
        {" "}
        <b>Mercedes A Klasse</b>
        {" "}
        ist eine Kompaktlimousine, welche
        sich nicht nur durch ihre Alltagstauglichkeit im Stadtverkehr behauptet, sondern auch
        durch die vielen Interieur und Exterieur Highlights. Besonders zeichnet sich die
        {" "}
        <b>
          A
          Klasse
        </b>
        {" "}
        durch Interieur Highlights wie dem
        {" "}
        <b>
          A
          Klasse
        </b>
        , dem
        Sprachbediensystem
        {" "}
        <b>Linguatronic</b>
        {" "}
        oder dem
        {" "}
        <b>Head-Up Display</b>
        {" "}
        aus. Ein weiteres
        Feature was einer Augenweide ähnelt, ist die Mercedes-Benz
        <b>Ambientebeleuchtung</b>
        . Diese lässt sich individuelle anpassen und über die
        zahlreichen Kommunikationssysteme von Mercedes steuern. So wird auch das
        günstigste Modell der Mercedes flotte Dank den Produkthighlights zu ihrer
        persönlichen Wohlfühloase. das schon ab
        {" "}
        {minLeasingRate}
        .
      </p>
    </div>
    <div
      id="vip-leasing-mercedes-was-ist-das"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="paragraph font-bold mb-4">
        VIP Leasing Mercedes, was ist das?
      </h3>
      <p className="mb-4">
        Personen des öffentlichen Lebens sind ein Teil unserer Gesellschaft und zeichnen
        sich durch besondere Eigenschaften aus, welche Sie zu gern gesehenen
        Werbeträger macht. So können Youtuber, Sportler, TV-Stars und Musiker je nach
        Beliebtheitsgrad und Image auf das Mercedes VIP Leasing zugreifen. Diese Art des
        Leasing ermöglicht den Personen des öffentlichen Lebens Vorteile wie:
      </p>
      <p className="mb-4">
        <ul>
          <li>
            <b>Laufzeit</b>
            {" "}
            (Variabel 6-12 Monate)
          </li>
          <li>
            <b>Fahrleistung</b>
            {" "}
            (Unbegrenzt)
          </li>
          <li>
            <b>Höhe der Rate</b>
            {" "}
            (1% des Listenpreises)
          </li>
          <li>
            <b>Zusätzliche Leistungen</b>
            {" "}
            (Versicherung, Zulassung, KFZ-Steuer, Wartung und
            Verschleiß)
          </li>
        </ul>
      </p>
    </div>
    <div
      id="besondere-highlights-erleben-sie-bei-mercedes-benz"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="paragraph font-bold mb-4">
        Besondere Highlights erleben Sie bei Mercedes-Benz
      </h3>
      <p className="mb-4">
        Kaum ein Automobilhersteller kommt an diese Interieur-Highlights ran. Wenn Sie an
        Mercedes-Benz denken, dann denken Sie bestimmt an eine luxuriöse Karosserie,
        gepaart mit glänzenden Aluminiumfelgen und Ledersitzen. Sollte das der Fall sein,
        dann liegen Sie richtig. Doch Mercedes hat mehr zu bieten als nur die glanzvolle
        äußerliche Erscheinung. Laut dem Magazin Auto Motor Sport wurde der
        Mercedes-Benz Innenraum von 16.000 Lesern zu dem schönsten Innenraum 2020
        gekürt.
      </p>
    </div>
    <div
      id="diese-statistik-spricht-fur-sich"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="paragraph font-bold mb-4">
        Diese Statistik spricht für sich.
      </h3>
      <p className="mb-4">
        Nicht umsonst wurde der Mercedes Innenraum zu dem schönsten Innenraum 2020
        gekürt. Jedes Jahr überrascht Mercedes-Benz durch noch höhere
        Qualitätsstandards und neue Technologie, welche den Komfort und die Sicherheit
        der Fahrzeuge weiter erhöhen.
      </p>
      <p className="mb-4">
        Ob Gesten- oder Sprachbediensystem, zusammen mit dem
        {" "}
        <b>MBUX System</b>
        {" "}
        haben
        Sie die volle Kontrolle über sämtliche Features des Infotainment Systems. Mit der
        <b>MBUX Fond</b>
        {" "}
        und der
        {" "}
        <b>MBUX Augmented Reality </b>
        {" "}
        können Sie sich ihr Cockpit
        personalisiert gestalten und in die attraktive Erlebniswelt von Mercedes eintauchen.
        Mit dem MBUX Augmented Reality System wurde ein neuer Maßstab für Navigation
        gesetzt. Mit der AR live Navigation werden ihnen Navigationshinweise in ihr
        Head-Up Display eingeblendet. Des Weiteren, kann die live Navigation ebenfalls
        über die zwei integrierten 10,25 Zoll-Displays angezeigt werden.
      </p>
    </div>
    <div
      id="starke-technologie-und-modernes-design"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="paragraph font-bold mb-4">
        Starke Technologie und modernes Design
      </h3>
      <p className="mb-4">
        Über das großzügige Display, welches in der Headunit fließend integriert wurde,
        können Sie spielend leicht auf sämtliche Streamingdienste wie
        {" "}
        <b>Spotify</b>
        ,
        {" "}
        <b>Apple Music</b>
        {" "}
        und weitere problemlos zugreifen. Durch das optimierte Hochleistungs
        Display ist die Interaktion mit dem Infotainment System flüssig, intuitiv und
        Nutzerfreundlich. Um als Fahrer auch während der Fahrt von den Features, wie dem
        {" "}
        <b>Apple Carplay</b>
        {" "}
        gebrauch zu machen, lässt sich dieses Feature wie viele andere
        problemlos über die Bedienelemente am Lenkrad steuern.
      </p>
    </div>
    {/* Der sportliche SUV mit der neuesten Technik: der Audi Q3 */}
    <div
      id="so-geht-innovation-erleben-sie-technik-schon-jetzt"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="paragraph font-bold mb-4">
        So geht Innovation - Erleben Sie Technik schon jetzt!
      </h3>
      <p className="mb-4">
        In den letzten zwei Jahrzehnten entwickelte sich nicht nur die Marke Mercedes zu
        einem nachhaltigen und innovativen Unternehmen weiter, sondern insbesondere ihre
        Produkte. Mit der vollelektrischen Fahrzeugreihe
        {" "}
        <b>Mercedes EQ</b>
        , erleben Sie Electric
        Intelligence und Elektromobilität, wie es sie zuvor noch nicht gab.
      </p>
      <p className="mb-4">
        Durch den Allrad angetriebenen Motor des
        {" "}
        <b>EQCs</b>
        , fahren Sie geräuschlos und sicher
        durch jedes Terrain. Mit Hilfe der intuitiven Steuerung des kompakt
        {" "}
        <b>SUVs</b>
        , lässt sich
        der vollelektrische Bruder des
        {" "}
        <b>GLCs</b>
        {" "}
        mühelos durch die Stadt und weitere
        Landschaften navigieren, ohne dass der Komfort verloren geht. Durch Sicherheit
        Highlights wie dem
        {" "}
        <b>Fahrassistenz-Paket</b>
        , dem
        {" "}
        <b>Park-Paket inklusive 360°-Kamera</b>
        ,
        dem
        {" "}
        <b>Anhängerrangierassistent</b>
        {" "}
        und den
        {" "}
        <b>MULTIBEAM LED</b>
        {" "}
        Scheinwerfern erwartet
        Sie bei
        {" "}
        <b>Mercedes-Benz</b>
        {" "}
        das höchste Maß an Sicherheit, für Sie und ihre Familie.
      </p>
      <p className="mb-4">
        Wer denkt, dass der
        {" "}
        <b>Mercedes EQC</b>
        {" "}
        durch seine größe keine Power hat, der hat
        sich geirrt. Durch seine
        {" "}
        <b>408 PS</b>
        {" "}
        beschleunigt der SUV in nur
        {" "}
        <b>5,8 Sekunden</b>
        ansatzlos auf
        {" "}
        <b>100 km/h</b>
        {" "}
        und hängt so vergleichbare kompakt SUVs mühelos ab.
        Durch seinen
        {" "}
        <b>300 kW</b>
        {" "}
        Elektromotor ist die auf zwei Antriebsstränge aufgeteilte Kraft,
        bereits aus dem stand einsetzbar, was den 2,5 Tonner spürbar stark bei
        Beschleunigung nach vorne katapultiert.
      </p>
      <p className="mb-4">
        Doch nicht nur durch seine Leistung glänzt der
        {" "}
        <b>EQC</b>
        . Besonders durch seine lange
        Reichweite überzeugt der futuristische Mercedes. Mit einer Reichweite von über 420
        Kilometern, hält der Stuttgarter locker mit Konkurrenten wie dem
        {" "}
        <b>Audi E-tron</b>
        {" "}
        oder
        dem
        {" "}
        <b>BMW i3</b>
        {" "}
        mit. Der Mercedes EQC ist bei Null-Leasing als Mercedes Leasing
        erhältlich.
      </p>
      <p className="mb-4">
        Doch auch die
        {" "}
        <b>Mercedes Hybrid</b>
        {" "}
        Flotte ist bei
        {" "}
        <a
          className="link link--secondary"
          target="_blank"
          href="/home"
        >
          Null-Leasing
        </a>
        {" "}
        erhältlich. Das Gemisch
        aus Elektro und Benzinmotoren machen die Mercedes Plug-In Hybrid Modelle zu
        wahren Schätzen. Die Vorteile eines Mercedes Hybriden sind eindeutig. Mehr
        Reichweite, bessere Beschleunigung und ein geringerer Verbrauch.
      </p>
    </div>
    <div
      id="was-bedeutet-avantgarde-bei-mercedes"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="paragraph font-bold mb-4">
        Was bedeutet Avantgarde bei Mercedes?
      </h3>
      <p>
        Die Avantgarde Ausstattungslinie von Mercedes-Benz verbindet die besten
        Designelemente des Hauses. Zierelemente, dynamische Leichtmetallräder und das
        {" "}
        <b>AGILITY CONTROL Fahrwerk</b>
        {" "}
        mit selektivem Dämpfungssystem und Tieferlegung,
        ist nur ein Teil des Avantgarde Paketes welches das elegante Design der
        Mercedes-Benz Modelle hervorhebt und die Sportlichkeit betont. Diese
        Ausstattungslinie ist bei diversen Mercedes-Benz Modellen auf Null-Leasing
        verfügbar.
      </p>
    </div>
    <div
      id="ob-alt-oder-neu-amg-bringt-power"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="paragraph font-bold mb-4">Ob alt oder neu - AMG bringt Power!</h3>
      <p className="mb-4">
        Wenn Power, dann AMG! Die aus Affalterbach stammende Tochtergesellschaft von
        Mercedes-Benz ist das High Performance Herzstück, des süddeutschen
        Automobilherstellers. Die drei Buchstaben die eine ganze Szene geprägt haben
        setzen sich aus den Anfangsbuchstaben der Nachnamen der beiden Gründer und
        dem der Gründungsstätte zusammen. Der Markenname AMG steht demnach für
        Hans Werner
        {" "}
        <b>A</b>
        ulrich, Erhart
        {" "}
        <b>M</b>
        elcher und dem Ort
        {" "}
        <b>G</b>
        ründungsort Großaspach.
      </p>
      <p className="mb-4">
        Bekannt ist die Marke AMG vor allem für seine Turbo aufgeladenen V8 Maschinen,
        welche nicht nur für einen satten Sound sorgen, sondern auch für eine große Portion
        Schub. Laut den beiden Gründern der Marke war die ursprüngliche Idee, die
        hochtourigen Motoren nur im Rennsport einzusetzen. Doch nach etlichen Jahren
        Ingenieurskunst haben sich die Entwickler dazu entschieden, die
        Hochleistungsmotoren in Kraftfahrzeuge der Daimler AG zu verbauen. So war die
        Vision der beiden Gründer, dass diese Technologie für Non-Rennfahrer zugänglich
        gemacht wird.
      </p>
      <p className="mb-4">
        Mit einem Mercedes Leasing können Sie bereits für
        {" "}
        <b>
          {minLeasingRate}
          {" "}
          im Monat
        </b>
        {" "}
        in den Genuss
        eines waschechten Rennfahrzeuges, mit Straßenzulassung kommen.
      </p>
    </div>
    <div
      id="was-kostet-ein-amg"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="paragraph font-bold mb-4">Was kostet ein AMG?</h3>
      <p className="mb-4">
        Der Mercedes
        {" "}
        <b>A35 AMG</b>
        {" "}
        ist der kleinste der Baureihe aus Affalterbach. Mit einem
        Rund 306 PS starken 2 Liter Benzinmotor, beschleunigt der sportliche
        Kompaktwagen in nur 4,7 Sekunden von 0 auf 100 km/h. Erhältlich ist die sportliche
        Kompaktlimousine bereits ab einem Basispreis von 47.529€ oder zu einer
        Leasingrate von
        {" "}
        {minLeasingRate}
        {" "}
        bei Null-leasing.com.
      </p>
      <p className="mb-4">
        Wer es größer und schneller Mag, aber dennoch den Komfort einer Limousine
        bevorzugt wird mit dem
        {" "}
        <b>C63 AMG</b>
        {" "}
        glücklich. Der
        {" "}
        <b>8 Zylinder V8 Biturbo</b>
        {" "}
        des C63
        AMG befördert den sportlichen
        {" "}
        <b>5-Sitzer</b>
        {" "}
        in nur
        {" "}
        <b>4,2 Sekunden</b>
        {" "}
        von
        {" "}
        <b>0 auf 100 km/h</b>
        . In
        der kraftvollsten Version des C Klassen AMGs, hat der
        {" "}
        <b>C63s AMG</b>
        {" "}
        satte 34 PS mehr
        unter der Haube und beschleunigt dank seinen 9-Gängen in 4 Sekunden von
        {" "}
        <b>
          0 auf
          100
        </b>
        .
      </p>
    </div>
    <div
      id="was-kostet-der-teuerste-mercedes"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="paragraph font-bold mb-4">Was kostet der teuerste Mercedes?</h3>
      <p className="mb-4">
        Das derzeit teuerste und wohl luxuriöseste Modell von Mercedes ist der
        {" "}
        <b>
          S65 AMG
          Coupé
        </b>
        . Mit einem Grundpreis von 244.000 Euro strahlt nicht nur das Exterieur
        Luxus aus, sondern auch der Preis. Doch die sportliche Luxuslimousine hält was sie
        verspricht. Von bestickten Sitzen, bis hin zu dem Burmester High-End
        4D-Surround-Soundsystem, ist in dieser Limousine alles dabei.
      </p>
    </div>
    <div
      id="mehr-luxus-geht-nicht"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="paragraph font-bold mb-4">Mehr Luxus geht nicht!</h3>
      <p className="mb-4">
        Sollten die luxuriösen Limousinen für Sie trotz der hohe Leistung noch nicht
        genügend Rennwagencharakter haben, werden Sie von dem grimmigen Look des
        <b>AMG GT Coupe</b>
        {" "}
        erstaunt sein. Das Biest aus Affalterbach holt Performance von der
        Rennstrecke auf die Straße. Durch seine Breiten Reifen, sein zentrales MonoEndrohr
        und seinem Racing Heckspoiler, setzt dieser den Maßstab an Sportlichkeit
        von Mercedes-Benz. Das Leichtgewicht beschleunigt so, mit seinen über 500 PS in
        knapp über 3 Sekunden von 0 auf 100 km/h und gilt als die wohl schnellste Baureihe
        von Mercedes-Benz.
      </p>
      <p className="mb-4">
        <b>
          Werden Sie jetzt ein Teil der Mercedes Familie und finden Sie ihren Mercedes-Benz
          Traumwagen unter den zahlreichen Mercedes Leasing Angeboten auf
          {" "}
          <a
            className="link link--secondary"
            target="_blank"
            href="/home"
          >
            Null-Leasing.
          </a>
        </b>
      </p>
    </div>
  </div>
);
